<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="400px"
    :innerScroll="false"
    @close="onCancel"
    :loading="loadingBth"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px" v-loading="loading">
      <el-row>
        <el-col :span="24">
          <el-form-item label="商品编码:" prop="goodsCode">
            <el-input v-model.trim="addForm.goodsCode" size="small" @blur="getGoodsName(addForm.goodsCode)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="商品名称:" prop="goodsName">
            <span>{{addForm.goodsName}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "新增";
    },
  },
  data() {
    return {
      loading: false,
      loadingBth: false,
      addForm: {},
      rules: {
        goodsCode: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
      },
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  created() {},
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingBth = true;
        this.$q.dataImport
          .unAssessGoodsAdd({ data: this.addForm })
          .then((res) => {
            if (res.success) {
              this.$message.success(`${this.title}成功`);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingBth = false;
          });
      });
    },
    getGoodsName(val) {
      if(!val) {
        this.$set(this.addForm,'goodsName','')
        return
      }
      let data = {...this.currencyForm}
      data.reportCode = "getGoodsNameByCode";
      data.param = {
        goodsCode: val
      }
      axios.post(`/ec-pc-api/custom/reports/data/getGoodsNameByCode`, data).then((res) => {
        let goodsName = res.data.list ? res.data.list[0].goodsName : ''
        this.$set(this.addForm,'goodsName',goodsName)
      });
    },
    async init() {},
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 200px !important
>>> .el-input
  width 200px !important
</style>
